// extracted by css-extract-rspack-plugin
export default {"cls1":"search_work_card_redesign-cls1_pzT","cls2":"search_work_card_redesign-cls2_Aed search_work_card_redesign-cls1_pzT"};